export default "__VITE_ASSET__CoSqsvMF__"